MINIMUM_FONT_SIZE_STATIC = 8
MINIMUM_FONT_SIZE_SCROLL = 12
FONT_SIZE_DECREMENT = 0.5
DEFAULT_CLONE_STYLE =
  position: "absolute"
  top: "-100%"
  left: "-100%"
  visibility: "hidden"
  fontSize: ""

makeClone = (el) ->
  style = window.getComputedStyle(el)
  clone = el.cloneNode()
  clone.innerHTML = el.innerHTML

  for key, val of DEFAULT_CLONE_STYLE
    clone.style[key] = val

  for attr in ["width", "height", "padding", "border"]
    clone.style[attr] = style[attr]

  clone.classList.add("content-fit-clone")

  clone

makeSpacer = ->
  spacer = document.createElement("div")
  spacer.id = "content-spacer"
  spacer

module.exports = (el, done) ->
  return done?() unless el

  minFontSize =
    if window.getComputedStyle(el).overflow is "auto"
      MINIMUM_FONT_SIZE_SCROLL
    else
      MINIMUM_FONT_SIZE_STATIC

  el.classList.add("fitting")
  el.classList.remove("fitted")

  parent = el.parentNode
  clone  = makeClone(el)
  spacer = makeSpacer()
  active = true

  parent.appendChild(clone)
  clone.appendChild(spacer)

  fontSize  = parseFloat(window.getComputedStyle(parent).fontSize)
  fitHeight = parent.offsetHeight

  do repeat = (top) ->
    return unless active

    if top isnt spacer.offsetTop
      window.setTimeout (-> repeat(spacer.offsetTop)), 0
    else if spacer.offsetTop > fitHeight and fontSize > minFontSize
      fontSize -= FONT_SIZE_DECREMENT
      clone.style.fontSize = "#{fontSize}px"
      repeat(top)
    else
      el.style.fontSize = clone.style.fontSize
      el.offsetHeight
      el.classList.remove("fitting")
      el.classList.add("fitted")
      done?()
      clone.parentNode?.removeChild(clone)

  return { cancel: -> active = false }
